import styled from 'styled-components';
import LocaleLink from '@components/LocaleLink';

export const BreadcrumbContainer = styled.div`
  flex: 1;
  margin: 0;
  align-content: center;
`;

export const StyledLocaleLink = styled(LocaleLink)`
  display: inline-block !important;
`;

export const BreadcrumbElementContainer = styled.div`
  display: inline-block;
`;
export const BreadcrumbElementLabel = styled.div`
  display: inline-block;
`;

export const BreadcrumbElementSeparator = styled.span`
  padding-left: '8px';
  padding-right: '8px';
`;
